import { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { CaretDown, CaretRight } from "@phosphor-icons/react";
import { Pill } from "@/components/admin/AdminUI";
import { formatDate } from "@/lib/format";
import { pushCategoryLabel, pushStatus, SAFETY_SUBS } from "@/lib/push";

function Fact({ label, value }) {
  return <div className="min-w-0"><dt className="cw-muted text-xs">{label}</dt><dd className="mt-0.5 break-all text-sm">{value || "—"}</dd></div>;
}

export default function PushLogRow({ e }) {
  const [open, setOpen] = useState(false);
  const st = pushStatus(e.status);
  return (
    <Fragment>
      <tr className="cursor-pointer border-b border-border transition-colors hover:bg-[var(--cw-surface)]" onClick={() => setOpen((o) => !o)} data-testid={`push-row-${e.id}`}>
        <td className="py-3 pl-4"><button aria-expanded={open} aria-label={open ? "Collapse" : "Expand"} className="flex h-8 w-8 items-center justify-center rounded-lg" data-testid={`push-expand-button-${e.id}`}>{open ? <CaretDown size={14} /> : <CaretRight size={14} />}</button></td>
        <td className="cw-soft whitespace-nowrap py-3 pr-4 text-sm">{formatDate(e.created_at)}</td>
        <td className="py-3 pr-4"><Link to={`/admin/users/${e.user_id}`} onClick={(ev) => ev.stopPropagation()} className="font-mono text-xs underline-offset-2 hover:underline" data-testid={`push-user-link-${e.id}`}>{e.user_id}</Link></td>
        <td className="py-3 pr-4 text-sm">{pushCategoryLabel(e.category)}{e.sub && <span className="cw-muted block text-xs">{SAFETY_SUBS[e.sub] || e.sub}</span>}</td>
        <td className="py-3 pr-4"><Pill tone={st.tone} data-testid={`push-status-${e.id}`}>{st.label}</Pill></td>
        <td className="cw-soft max-w-[260px] truncate py-3 pr-4 text-sm">{e.body || "—"}</td>
        <td className="cw-muted py-3 pr-4 text-xs">{e.source || "app"}</td>
      </tr>
      {open && (
        <tr className="border-b border-border bg-[var(--cw-surface)]" data-testid={`push-detail-${e.id}`}>
          <td colSpan={7} className="px-4 py-4">
            <dl className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
              <Fact label="Title" value={e.title} /><Fact label="Opens" value={e.url} />
              <Fact label="Sent at" value={e.sent_at && formatDate(e.sent_at)} /><Fact label="Releases at" value={e.release_at && formatDate(e.release_at)} />
              <Fact label="Error" value={e.error} /><Fact label="Collapsed into" value={e.into} />
              <Fact label="Bundle" value={e.bundle_id} /><Fact label="Target" value={e.target && JSON.stringify(e.target)} />
            </dl>
            {e.tickets?.length > 0 && (
              <ul className="mt-4 space-y-1 text-xs" data-testid={`push-tickets-${e.id}`}>
                {e.tickets.map((t, i) => <li key={i} className="font-mono">{[t.status, t.ticket_id, t.error, t.receipt_status && `receipt ${t.receipt_status}`, t.receipt_error].filter(Boolean).join(" · ")}</li>)}
              </ul>
            )}
          </td>
        </tr>
      )}
    </Fragment>
  );
}
